import adminDashboardService from "../services/adminDashboardService";

export const GET_ALL_SUMMARIES_DASHBOARD_DATA =
  "GET_ALL_SUMMARIES_DASHBOARD_DATA";
export const GET_ALL_SUMMARIES_DASHBOARD_DATA_SUCCESS =
  "GET_ALL_SUMMARIES_DASHBOARD_DATA_SUCCESS";
export const GET_ALL_SUMMARIES_DASHBOARD_DATA_ERROR =
  "GET_ALL_SUMMARIES_DASHBOARD_DATA_ERROR";

// Get All Summaries Dashboard Data start
export function getAllSummariesDashboardDataRecord(query) {
  return async (dispatch) => {
    dispatch(getAllSummariesDashboardData());
    return await adminDashboardService
      .getAllSummariesDashboardData(query)

      .then((response) =>
        dispatch(getAllSummariesDashboardDataSuccess(response))
      )
      .catch((error) =>
        dispatch(getAllSummariesDashboardDataError(error))
      );
  };
}

export function getAllSummariesDashboardData() {
  return {
    type: GET_ALL_SUMMARIES_DASHBOARD_DATA,
  };
}

export function getAllSummariesDashboardDataSuccess(success) {
  return {
    type: GET_ALL_SUMMARIES_DASHBOARD_DATA_SUCCESS,
    payload: { success },
  };
}

export function getAllSummariesDashboardDataError(error) {
  return {
    type: GET_ALL_SUMMARIES_DASHBOARD_DATA_ERROR,
    payload: { error },
  };
}
// Get All Summaries Dashboard Data End